import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withTranslation } from 'react-i18next'; 

import React, { Component } from 'react'

import ObjBannerHeroComptoirDermato from './inc/ObjBannerHeroComptoirDermato'

import '../assets/css/0020_objects/0880_obj_intro_home_comptoir_dermato.css'
import '../assets/css/0020_objects/0890_obj_tabs_home_comptoir_dermato.css'
// TODO SGU créer un composant unique PageBrand_av et réunir ces sous-éléments
class PageBrandAv_Banner extends Component {
    constructor(props) {
		super(props)
		this.state = {
		}
	}

	render() {
        const { scDatas } = this.props.fields.data;

        return (<>{scDatas?.ListContentForPage[0]?.ListFolderBanners[0]?.ListBanners && <>
            <ObjBannerHeroComptoirDermato dataBanners={scDatas?.ListContentForPage[0]?.ListFolderBanners[0]?.ListBanners}/>
        </>}</>)
	}
}

export default withTranslation()(withSitecoreContext()(PageBrandAv_Banner));